import { graphql, useStaticQuery } from 'gatsby';
import { IAddOn } from '../types';

export type IAddOnsData = {
  posts: {
    edges: {
      node: IAddOn;
    }[];
  };
};

const useAddOnsData = (slug: string | null) => {
  const data: IAddOnsData = useStaticQuery(graphql`
    {
      posts: allStoryblokEntry(
        filter: { field_component: { eq: "conf-add-ons" } }
      ) {
        edges {
          node {
            id
            uuid
            name
            slug
            full_slug
            content
            created_at
          }
        }
      }
    }
  `);

  // If slug is null or an empty string, return all campaigns that start with "configurator"
  if (slug === null || slug === '') {
    return data.posts.edges
      .map((edge: any) => edge.node)
      .filter((node: any) => node.full_slug.startsWith('configurator'));
  }

  // Determine the language prefix from the slug
  const languagePrefix = slug?.split('/')[1] || ''; // Get the language part, or empty for root

  // Filter campaigns by the current language context
  const filteredAddOns = data.posts.edges
    .map((edge: any) => edge.node)
    .filter((node: any) => {
      if (languagePrefix) {
        // If in the /en/ path, match campaigns that have "en/" in their full_slug
        return node.full_slug.startsWith(`${languagePrefix}/`);
      } else {
        // If in the default page, match campaigns that start with "configurator"
        return node.full_slug.startsWith('configurator');
      }
    });

  return filteredAddOns;
};

export default useAddOnsData;
